import Icons, { IconsProps } from '../../Icons';

export type MoreHorizProps = IconsProps;

// https://www.zhangxinxu.com/sp/svgo/

export function MoreHoriz(props: MoreHorizProps) {
  return (
    <Icons {...props}>
      <path d="M6.45 13a.98.98 0 0 1-.7-.288.946.946 0 0 1-.3-.712c0-.283.1-.521.3-.713a.981.981 0 0 1 .7-.287c.283 0 .52.096.712.287.192.192.288.43.288.713s-.096.52-.288.712A.965.965 0 0 1 6.45 13ZM12 13a.965.965 0 0 1-.712-.288A.965.965 0 0 1 11 12c0-.283.096-.521.288-.713A.967.967 0 0 1 12 11a.97.97 0 0 1 .713.287A.97.97 0 0 1 13 12c0 .283-.096.52-.287.712A.968.968 0 0 1 12 13Zm5.55 0a.968.968 0 0 1-.713-.288.967.967 0 0 1-.287-.712.97.97 0 0 1 .287-.713.97.97 0 0 1 .713-.287c.267 0 .5.096.7.287.2.192.3.43.3.713s-.1.52-.3.712a.98.98 0 0 1-.7.288Z" />
    </Icons>
  );
}
